import { useEffect, useState } from "react";

export function useOtpCountdown(seconds = 5) {
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const startCountdown = () => setCountdown(seconds);

  const countdownFormatted = `00:${String(countdown).padStart(2, "0")}`;

  return { countdown, startCountdown, countdownFormatted };
}
